import * as R from 'ramda';
import { success, error } from './../common/helpers/constanHelpers';
import createReducer from './reducer-helpers/createReducer';
import { setLoading, setError, setSimpleError } from './reducer-helpers/reducerHelpers';

import {
  GET_USER_DETAILS,
  UPDATE_USER_BASIC_META,
  UPLOAD_PROFILE_PICTURE,
  CLEAR_USER,
  SET_PERMISSIONS,
  SET_LOCATION,
  DELETE_USER,
  UPDATE_USER_DATA,
  FETCH_BASIC_USERS,
  CREATE_USER
} from '../store/constants';

const INITIAL_STATE = {
  error: false,
  loading: false,
  success: false,
  data: {},
  updateError: false,
  updateLoading: false,
  updateSuccess: false,
  deleteError: false,
  deleteLoading: false,
  deleteSuccess: false,
  basicUsers: [],
  basicUsersLoading: false,
  basicUsersError: false,
  createError: false, 
  createLoading: false, 
  createSuccess: false, 
};

const setUpdateLoading = (_) =>
  R.evolve({
    updateLoading: R.always(true),
    updateSuccess: R.always(false),
    updateError: R.always(false),
  });

const setUpdateError = (_) =>
  R.evolve({
    updateLoading: R.always(false),
    updateError: R.always(true),
  });

const setDeleteLoading = (_) =>
  R.evolve({
    deleteLoading: R.always(true),
    deleteSuccess: R.always(false),
    deleteError: R.always(false),
  });

const setDeleteSuccess = (_) =>
  R.evolve({
    deleteLoading: R.always(false),
    deleteSuccess: R.always(true),
    deleteError: R.always(false),
  });

const setDeleteError = (_) =>
  R.evolve({
    deleteLoading: R.always(false),
    deleteError: R.always(true),
    deleteSuccess: R.always(false),
  });

const setBasicUsersLoading = (_) =>
  R.evolve({
    basicUsersLoading: R.always(true),
    basicUsersError: R.always(false),
  });

const setBasicUsersData = (action) =>
  R.evolve({
    basicUsersLoading: R.always(false),
    basicUsersError: R.always(false),
    basicUsers: () => R.clone(action.payload),
  });

const setBasicUsersError = (_) =>
  R.evolve({
    basicUsersLoading: R.always(false),
    basicUsersError: R.always(true),
    basicUsers: R.always([]),
  });

  const setCreateLoading = (_) =>
  R.evolve({
    createLoading: R.always(true),
    createSuccess: R.always(false),
    createError: R.always(false),
  });

const setCreateSuccess = (action) =>
  R.evolve({
    createLoading: R.always(false),
    createSuccess: R.always(true),
    createError: R.always(false),
    data: () => R.clone(action.payload),
  });

const setCreateError = (action) =>
  R.evolve({
    createLoading: R.always(false),
    createSuccess: R.always(false),
    createError: () => action.payload,
  });

const setActionData = (action) =>
  R.evolve({
    loading: R.always(false),
    success: R.always(true),
    data: () => R.clone(action.payload),
  });

const setUpdateActionData = (action) =>
  R.evolve({
    updateLoading: R.always(false),
    updateSuccess: R.always(true),
    data: () => R.clone(action.payload),
  });

const setSimpleData = (action) =>
  R.evolve({
    data: () => R.clone(action.payload),
  });

const setInitalState = (_) => (_) => R.clone(INITIAL_STATE);

const userReducer = createReducer(INITIAL_STATE, {
  [GET_USER_DETAILS]: setLoading,
  [success(GET_USER_DETAILS)]: setActionData,
  [error(GET_USER_DETAILS)]: setError,
  [UPDATE_USER_BASIC_META]: setUpdateLoading,
  [success(UPDATE_USER_BASIC_META)]: setUpdateActionData,
  [error(UPDATE_USER_BASIC_META)]: setUpdateError,
  [success(UPLOAD_PROFILE_PICTURE)]: setSimpleData,
  [error(UPLOAD_PROFILE_PICTURE)]: setSimpleError,
  [CLEAR_USER]: setInitalState,
  [SET_PERMISSIONS]: setUpdateLoading,
  [success(SET_PERMISSIONS)]: setUpdateActionData,
  [error(SET_PERMISSIONS)]: setUpdateError,
  [SET_LOCATION]: setLoading,
  [success(SET_LOCATION)]: setActionData,
  [error(SET_LOCATION)]: setError,
  [DELETE_USER]: setDeleteLoading,
  [success(DELETE_USER)]: setDeleteSuccess,
  [error(DELETE_USER)]: setDeleteError,
  [UPDATE_USER_DATA]: setUpdateLoading,
  [success(UPDATE_USER_DATA)]: setUpdateActionData,
  [error(UPDATE_USER_DATA)]: setUpdateError,
  [FETCH_BASIC_USERS]: setBasicUsersLoading,
  [success(FETCH_BASIC_USERS)]: setBasicUsersData,
  [error(FETCH_BASIC_USERS)]: setBasicUsersError,
  [CREATE_USER]: setCreateLoading,
  [success(CREATE_USER)]: setCreateSuccess,
  [error(CREATE_USER)]: setCreateError,
});

export default userReducer;